//cs-ecommerce/src/store/account/mutations.js
export function setUserData(state, val) {
    state.userData = val
}